export enum CouponType {
  FIXED = 'FIXED',
  PERCENT = 'PERCENT'
}

export interface BaseCoupon {
  id?: string;
  type: CouponType;
  propId: string;
  code: string;
  description?: string;
  minimumOrder?: number;
  expiry: Date;
}

export interface FixedCoupon extends BaseCoupon {
  type: CouponType.FIXED;
  discount: number;
}

export interface PercentCoupon extends BaseCoupon {
  type: CouponType.PERCENT;
  percent: number;
  maxDiscount?: number;
}

export type Coupon = FixedCoupon | PercentCoupon;
